export const navsList = [
    {
        pathname: "首页",
        pathUrl: "/home",
    },
    {
        pathname: "货源信息",
        pathUrl: "/information",
    },
    {
        pathname: "新闻中心",
        pathUrl: "/news",
    },
    {
        pathname: "合作伙伴",
        pathUrl: "/cooperation",
    },
    {
        pathname: "关于我们",
        pathUrl: "/about",
    },
    {
        pathname: "联系我们",
        pathUrl: "/contact",
    }
];
export const titleObj = {
    information: {
        title: "货源信息",
        text: "Supply information",
    },
    about: {
        title: "关于我们",
        text: "Supply information",
    },
    contact: {
        title: "联系我们",
        text: "contact us",
    },
    cooperation: {
        title: "合作伙伴",
        text: "Partner",
    },
    news: {
        title: "新闻中心",
        text: "News Center",
    },
};
